import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';

// #813: Sentry frontend APM. No DSN → no-op. Must run before render so
// render errors captured by the ErrorBoundary route into an active hub.
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || '';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    // #886: dedicated REACT_APP_SENTRY_ENVIRONMENT so preview can tag
    // separately without changing REACT_APP_ENV (and without touching
    // the backend's ENV guard). Falls back to REACT_APP_ENV for BC.
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.REACT_APP_ENV || 'development',
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
    beforeSend(event) {
      if (event.request && event.request.data) {
        event.request.data = '[scrubbed]';
      }
      // #1137: belt-and-braces — if Sentry surfaces request.headers on an
      // event (depends on integration version), strip the impersonation
      // grant before transport. Case-insensitive walk because
      // event.request.headers casing varies between integrations.
      if (event.request && event.request.headers) {
        const headers = event.request.headers;
        Object.keys(headers).forEach((k) => {
          if (k.toLowerCase().includes('impersonat')) {
            headers[k] = '[scrubbed]';
          }
        });
      }
      return event;
    },
    // #1137: axios xhr breadcrumbs include `data.request_headers` when the
    // axios integration is enabled. Drop X-Impersonation-Grant (any casing)
    // before the breadcrumb is appended to the buffer; this also defends
    // any future fetch breadcrumb shape that exposes request_headers.
    beforeBreadcrumb(breadcrumb) {
      const reqHeaders = breadcrumb && breadcrumb.data && breadcrumb.data.request_headers;
      if (reqHeaders && typeof reqHeaders === 'object') {
        Object.keys(reqHeaders).forEach((k) => {
          if (k.toLowerCase().includes('impersonat')) {
            reqHeaders[k] = '[scrubbed]';
          }
        });
      }
      return breadcrumb;
    },
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
  });
  // eslint-disable-next-line no-console
  console.info('Sentry frontend initialized');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
